/* AagamStuti product photos on phones. The photos sit side by side and swipe, and a tap opens a full-screen viewer with zoom.
   Linked by sections/main-product.liquid. aagamstuti.js still picks the photo for a chosen size or colour; this follows it. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  var gal = $('[data-gallery]'), main = gal && $('.as-gal__main', gal);
  if (!main || !window.matchMedia) return;
  var mq = matchMedia('(max-width: 860px)'), calm = matchMedia('(prefers-reduced-motion: reduce)');
  var slides = $$('.as-gal__slide', gal), count = $('[data-gallery-count]', gal);
  if (!slides.length) return;
  var track = null, mo = null, current = 0, syncing = false, frame = 0, settleAt = 0;

  function isImg(s) { var f = s.firstElementChild; return !!f && f.tagName === 'IMG'; }
  function chosen() { for (var k = 0; k < slides.length; k++) if (!slides[k].hidden) return k; return 0; }

  /* keep the counter, the thumbnails and the core's hidden flags in step with the slide in view */
  function paint(i) {
    current = i;
    if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    var id = slides[i].getAttribute('data-media-id');
    $$('[data-media-target]', gal).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-target') === id ? 'true' : 'false'); });
    syncing = true;
    slides.forEach(function (s, k) { s.hidden = k !== i; });
    setTimeout(function () { syncing = false; }, 0);
  }
  function goTo(i, smooth) {
    if (!track) return;
    settleAt = smooth && !calm.matches ? Date.now() + 500 : 0;
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !calm.matches ? 'smooth' : 'auto' });
  }
  function onScroll() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () {
      if (Date.now() < settleAt) { setTimeout(onScroll, settleAt - Date.now() + 20); return; }
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      if (i !== current && i >= 0 && i < slides.length) paint(i);
    });
  }
  function onHidden() {
    if (syncing) return;
    var k = chosen();
    current = k;
    goTo(k, true);
  }

  function enable() {
    if (track) return;
    track = doc.createElement('div');
    track.className = 'as-gal__track';
    track.setAttribute('role', 'region'); track.setAttribute('aria-roledescription', 'carousel'); track.setAttribute('aria-label', 'Product photos');
    main.insertBefore(track, slides[0]);
    slides.forEach(function (s, i) {
      track.appendChild(s);
      s.setAttribute('role', 'group'); s.setAttribute('aria-roledescription', 'slide'); s.setAttribute('aria-label', (i + 1) + ' of ' + slides.length);
      if (isImg(s)) {
        var im = s.firstElementChild;
        im.setAttribute('role', 'button'); im.setAttribute('tabindex', '0'); im.setAttribute('aria-label', 'Open photo ' + (i + 1) + ' of ' + slides.length + ' larger');
      }
    });
    gal.classList.add('as-gal--swipe');
    current = chosen();
    goTo(current, false);
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('click', function (e) {
      var s = e.target.closest('.as-gal__slide');
      if (s && isImg(s) && e.target.tagName === 'IMG') open(slides.indexOf(s));
    });
    track.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.tagName === 'IMG' && e.target.getAttribute('role') === 'button') { e.preventDefault(); open(slides.indexOf(e.target.parentNode)); }
    });
    mo = new MutationObserver(onHidden);
    mo.observe(track, { attributes: true, attributeFilter: ['hidden'], subtree: true });
  }
  function disable() {
    if (!track) return;
    mo.disconnect(); mo = null;
    slides.forEach(function (s) {
      main.insertBefore(s, track);
      s.removeAttribute('role'); s.removeAttribute('aria-roledescription'); s.removeAttribute('aria-label');
      if (isImg(s)) { var im = s.firstElementChild; im.removeAttribute('role'); im.removeAttribute('tabindex'); im.removeAttribute('aria-label'); }
    });
    track.remove(); track = null;
    gal.classList.remove('as-gal--swipe');
    paint(current);
  }

  /* ---------- full-screen viewer ---------- */
  var box = null, lbTrack = null, lbN = null, lbZoom = null, items = [], lbMap = [], lbCur = 0, opener = null, lbFrame = 0, lastTap = 0;
  function build() {
    box = doc.createElement('div');
    box.className = 'as-lbx'; box.hidden = true;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Photo viewer');
    box.innerHTML = '<div class="as-lbx__bar"><p class="as-lbx__n" role="status"></p><button type="button" class="as-lbx__btn" data-lbx-zoom aria-pressed="false">Zoom in</button><button type="button" class="as-lbx__btn" data-lbx-close>Close</button></div><div class="as-lbx__track" tabindex="0" role="region" aria-label="Enlarged product photos"></div><p class="as-lbx__hint">Swipe for the next photo. Pinch or double-tap to zoom.</p>';
    lbTrack = $('.as-lbx__track', box); lbN = $('.as-lbx__n', box); lbZoom = $('[data-lbx-zoom]', box);
    slides.forEach(function (s, i) {
      if (!isImg(s)) return;
      var src = s.firstElementChild, item = doc.createElement('div'), z = doc.createElement('div'), im = doc.createElement('img');
      item.className = 'as-lbx__item'; z.className = 'as-lbx__zoom';
      im.src = src.getAttribute('src'); im.alt = src.getAttribute('alt') || ''; im.loading = 'lazy'; im.decoding = 'async';
      z.appendChild(im); item.appendChild(z); lbTrack.appendChild(item);
      lbMap.push(i); items.push(item);
    });
    doc.body.appendChild(box);
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-lbx-close]')) { close(); return; }
      if (e.target.closest('[data-lbx-zoom]')) { setZoom(!box.classList.contains('is-zoomed')); return; }
      if (e.target.closest('.as-lbx__zoom')) {
        var now = Date.now();
        if (now - lastTap < 320) { setZoom(!box.classList.contains('is-zoomed')); lastTap = 0; } else lastTap = now;
      }
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var f = $$('button', box), first = f[0], last = f[f.length - 1];
        if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      } else if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && !box.classList.contains('is-zoomed')) {
        e.preventDefault();
        lbTrack.scrollTo({ left: (lbCur + (e.key === 'ArrowRight' ? 1 : -1)) * lbTrack.clientWidth, behavior: calm.matches ? 'auto' : 'smooth' });
      }
    });
    lbTrack.addEventListener('scroll', function () {
      cancelAnimationFrame(lbFrame);
      lbFrame = requestAnimationFrame(function () {
        var k = Math.round(lbTrack.scrollLeft / Math.max(lbTrack.clientWidth, 1));
        if (k >= 0 && k < items.length && k !== lbCur) { lbCur = k; label(); }
      });
    }, { passive: true });
  }
  function label() { lbN.textContent = 'Photo ' + (lbCur + 1) + ' of ' + items.length; }
  function setZoom(on) {
    box.classList.toggle('is-zoomed', on);
    lbZoom.setAttribute('aria-pressed', on ? 'true' : 'false');
    lbZoom.textContent = on ? 'Zoom out' : 'Zoom in';
    items.forEach(function (it, k) { it.classList.toggle('is-zoomed', on && k === lbCur); });
    if (on) {
      var z = $('.as-lbx__zoom', items[lbCur]);
      requestAnimationFrame(function () { z.scrollLeft = (z.scrollWidth - z.clientWidth) / 2; z.scrollTop = (z.scrollHeight - z.clientHeight) / 2; });
    }
  }
  function open(slideIndex) {
    if (!box) build();
    var k = lbMap.indexOf(slideIndex);
    if (k < 0) return;
    opener = doc.activeElement;
    box.hidden = false; root.classList.add('as-lbx-open');
    setZoom(false);
    lbCur = k; lbTrack.scrollLeft = k * lbTrack.clientWidth; label();
    $('[data-lbx-close]', box).focus();
  }
  function close() {
    box.hidden = true; root.classList.remove('as-lbx-open'); setZoom(false);
    if (opener && opener.focus) opener.focus();
  }

  function sync() { if (mq.matches) enable(); else disable(); }
  if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
  sync();
})();
